import React, { createContext, useContext, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import adminApi from '../utils/adminApi';

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [adminToken, setAdminToken] = useState(() => localStorage.getItem('admin_token') || '');
  const [adminUsername, setAdminUsername] = useState(() => localStorage.getItem('admin_username') || '');
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const login = async ({ username, password }) => {
    setIsLoggingIn(true);
    try {
      const response = await adminApi.post('/admin/login', { username, password });
      const token = response?.data?.token;
      const uname = response?.data?.username || username;

      if (!token) {
        throw new Error('Admin token missing');
      }

      localStorage.setItem('admin_token', token);
      localStorage.setItem('admin_username', uname);
      setAdminToken(token);
      setAdminUsername(uname);
      toast.success('Admin login successful');
      return true;
    } catch (error) {
      const message = error?.response?.data?.message || error?.message || 'Admin login failed';
      toast.error(message);
      return false;
    } finally {
      setIsLoggingIn(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_username');
    setAdminToken('');
    setAdminUsername('');
    toast.info('Admin logged out');
  };

  const value = useMemo(() => ({
    isAdminAuthenticated: Boolean(adminToken),
    adminToken,
    adminUsername,
    isLoggingIn,
    login,
    logout,
  }), [adminToken, adminUsername, isLoggingIn]);

  return <AdminAuthContext.Provider value={value}>{children}</AdminAuthContext.Provider>;
};

export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error('useAdminAuth must be used within AdminAuthProvider');
  }
  return context;
};
